import React, { Component } from "react";
import { Link } from "gatsby";
import HeaderLogo from "./HeaderLogo"
import SocialLink from "./SocialLink"
import SocialLinksIcons from "./SocialLinksIcons"

class Sidebar extends Component {
    constructor(props){
        super(props)
        this._links_data = [
            { name: "Github", class: "icon brands fa-github", link:"https://github.com/naxrohan"},
            { name: "Linkedin", class: "icon brands fa-linkedin", link: "https://www.linkedin.com/in/dsouza-rohan"},
            { name: "Email", class: "icon solid fa-envelope", link: "mailto:rohan.jd@hotmail.com"} ,
            { name: "Stackoverflow", class: "icon fa-stack-overflow", link: "https://stackoverflow.com/users/3629131/naxrohan"}
         ]
    }
    render() {
        const SocialLinks = this._links_data.map((data, i) =>
            <SocialLink
                key={i}
                name={data.name}
                class={data.class}
                link={data.link} />
        );
        return (
            <div id="header">

                <div className="top">

                    <HeaderLogo 
                        image="/images/avatar.jpg" 
                        title="Rohan Dsouza" 
                        desig="Full Stack Developer"/>

                    <nav id="nav">
                        <ul>
                            <li><Link exact to="/"><span className="icon solid fa-home">Home</span></Link></li>
                            <li><Link to="/apps/"><span className="icon solid fa-th">Apps</span></Link></li>
                            <li><Link to="/about/"><span className="icon solid fa-blog">About</span></Link></li>
                        </ul>
                    </nav>

                </div>

                <SocialLinksIcons >
                    {SocialLinks}
                 </SocialLinksIcons>
            </div>
        );
    }
}

export default Sidebar;